import { API } from "../../api/api.js";
let loggingEnabled = false;
export const isLoggingEnabled = () => loggingEnabled;
export const holdsWorkerMessage = (ev) => {
    return (ev.data instanceof Object &&
        ev.data.hasOwnProperty("operation") &&
        ev.data.hasOwnProperty("payload"));
};
export const isWorkerError = (ev) => {
    return (ev.data instanceof Object &&
        ev.data.hasOwnProperty("operation") &&
        ev.data.hasOwnProperty("error"));
};
export const getRequestHandler = (ctx, listeners) => {
    return (ev) => {
        if (holdsWorkerMessage(ev)) {
            const listener = listeners[ev.data.operation];
            if (listener) {
                listener.call(ctx, send(ev.ports[0], ev.data.operation), transfer(ev.ports[0], ev.data.operation), ...ev.data.payload);
            }
            else {
                //unknown operation
                ev.ports[0].postMessage({
                    operation: ev.data.operation,
                    arguments: [],
                    error: `UNKNOWN_OPERATION: ${ev.data.operation}`,
                });
            }
        }
        else {
            console.trace(`Message event does not contain a WorkerMessage. MessageEvent.data=${JSON.stringify(ev.data)}`);
            ev.ports[0].postMessage({
                operation: "__error__",
                arguments: [ev.data],
                error: "NO_WORKER_MESSAGE",
            });
        }
    };
};
export const getResponseHandler = (ctx, port, resolve, reject) => {
    return (ev) => {
        port.close();
        if (!ev.data.error) {
            resolve(ev.data.payload);
        }
        else {
            reject(ev.data.error);
        }
    };
};
export const transfer = (messagePort, operation) => (transferables, ...messageArguments) => {
    messagePort.postMessage({
        operation,
        payload: transferables.concat(messageArguments),
    }, transferables);
};
export const send = (messagePort, operation) => (...messageArguments) => {
    messagePort.postMessage({
        operation,
        payload: messageArguments,
    });
};
export const call = function (sender, operation, parameters, handler, transferables) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await messagePromise(sender, self, {
                operation: operation,
                payload: parameters,
            }, transferables);
            resolve(handler ? handler(...result) : result[0]);
        }
        catch (error) {
            reject(error);
        }
    });
};
export const authenticate = (worker, host) => {
    return (domain, credentials) => {
        return call(worker, "authenticate", [host, domain, credentials]);
    };
};
export const authenticateRequestHandler = async (send, _transfer, host, domain, credentials) => {
    API.init(host ?? "", false); //do not use local storage
    API.setDomain(domain);
    if (credentials) {
        if (typeof credentials === 'string') {
            API.setCredentials(credentials, undefined);
        }
        else {
            const { usr, pwd } = credentials;
            API.setCredentials(usr, pwd);
        }
    }
    else {
        API.setCredentials(undefined, undefined);
    }
    const settings = await API.signIn();
    send(settings);
};
export const enableLogging = (worker) => {
    return (enable) => {
        return call(worker, "enableLogging", [enable]);
    };
};
export const enableLoggingRequestHandler = async (_send, _transfer, logging) => {
    loggingEnabled = logging === true;
};
export const messagePromise = async (sender, ctx, message, transferables) => new Promise((resolve, reject) => {
    const channel = new MessageChannel();
    channel.port1.onmessage = getResponseHandler(ctx, channel.port1, resolve, reject);
    sender.postMessage(message, transferables ? transferables.concat([channel.port2]) : [channel.port2]);
});
